/**
 * Auth0 Configuration
 * Reads from environment variables set in .env.local
 */

export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN || 'your-tenant.auth0.com',
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || 'your-client-id',
  authorizationParams: {
    audience: import.meta.env.VITE_AUTH0_AUDIENCE || 'https://api.logogen.com',
    redirect_uri: window.location.origin,
  },
};
